import React, { useEffect, useState } from "react";
import { fetchLeads } from "@/lib/adminApi";
import { PageHeader, StatCard } from "./_shared";
import LeadTable from "./LeadTable";
import LeadDrawer from "./LeadDrawer";

const DOWNLOAD_TYPES = ["brochure", "sponsorship_proposal", "prospectus", "market_report", "calculator_report"];

export default function DownloadsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  useEffect(() => {
    fetchLeads({ form_type: DOWNLOAD_TYPES.join(",") }).then((d) => { setRows(d); setLoading(false); });
  }, []);

  const count = (t) => rows.filter(r => r.form_type === t).length;
  const uncontacted = rows.filter(r => !r.extra?.contacted).length;

  return (
    <div data-testid="page-downloads">
      <PageHeader
        title="Download Leads"
        subtitle="Everyone who downloaded a brochure, sponsorship proposal, or market report. These are your warmest leads — hand them to sales."
      />

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
        <StatCard tone="lime" label="Brochure" value={count("brochure")} />
        <StatCard tone="amber" label="Sponsor Proposal" value={count("sponsorship_proposal")} />
        <StatCard label="Prospectus" value={count("prospectus")} />
        <StatCard label="Market Report" value={count("market_report")} />
        <StatCard tone="navy" label="Untouched" value={uncontacted} sub="Need outreach" />
      </div>

      {loading ? <div className="text-sm text-slate-500">Loading…</div> : (
        <LeadTable
          rows={rows}
          setRows={setRows}
          onRowClick={setActive}
          filename="bef2026-downloads.csv"
          filterableTypes={DOWNLOAD_TYPES}
          emptyText="No downloads yet."
        />
      )}

      <LeadDrawer
        lead={active}
        onClose={() => setActive(null)}
        onChange={(u) => { setRows((prev) => prev.map((x) => x.id === u.id ? u : x)); setActive(u); }}
        onDelete={(id) => setRows((prev) => prev.filter((x) => x.id !== id))}
      />
    </div>
  );
}
